<div class="bz-shadow--s">
  <div class="bz-space--inset-l">
    <div class="bz-font-size--body-small bz-font-weight--semibold bz-space--stack-m bmc-jobs-filter__header">
      {{'GLOBAL.SHOW_HIDE' | translate}}
      <a (click)="close()">
        <svg _ngcontent-c76="" class="bmc-jobs-filter__close"><use _ngcontent-c76="" href="#icon-close"></use></svg>
      </a>
    </div>
    <ul class="bmc-jobs-filter__list">
      <li *ngFor="let col of columnsToFilter" class="bz-space--stack-m bz-space--inline-xl">
        <bzg-checkbox [disabled]="col.blocked" [checked]="col.visible" (change)="change(col, $event)">
          {{ col.value | translate}}
        </bzg-checkbox>
      </li>
    </ul>
  </div>
  <div class="bmc-jobs-filter__footer bz-space--inset-m bz-color-border--neutral-200">
    <a class="bz-font-weight--semibold bz-font-size--body-small bz-color--theme-400 bz-space--inline-m" (click)="clearAll()">
      {{'GLOBAL.CLEAR_ALL' | translate}}
    </a>
    <bzg-button-secondary [size]="'s'" (click)="apply()">
      {{'GLOBAL.APPLY' | translate}}
    </bzg-button-secondary>

  </div>
</div>
